// Ref: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/components/accordion.ts

import { accordionAnatomy as parts } from '@chakra-ui/anatomy';
import {
    createMultiStyleConfigHelpers,
    defineStyle,
} from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } =
    createMultiStyleConfigHelpers(parts.keys);

const baseStyleContainer = defineStyle({
    borderTopWidth: 0,
    borderColor: 'inherit',
    _last: {
        borderBottomWidth: 0,
    },
});

const baseStyleButton = defineStyle({
    transitionProperty: 'common',
    transitionDuration: 'normal',
    fontSize: 'md',
    rounded: 'md',
    _focusVisible: {
        boxShadow: 'outline',
    },
    _hover: {
        bg: 'white',
    },
    _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
    },
    px: 0,
    py: 0,
});

const baseStylePanel = defineStyle({
    py: 0,
    px: 0,
});

const baseStyleIcon = defineStyle({
    fontSize: '1.25em',
});

const baseStyle = definePartsStyle({
    container: baseStyleContainer,
    button: baseStyleButton,
    panel: baseStylePanel,
    icon: baseStyleIcon,
});

const accordionTheme = defineMultiStyleConfig({ baseStyle });

export default accordionTheme;
